import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Spacer, Stack } from '@emburse/embark-core';
export default function ExceptionsLoading() {
    return (_jsxs(Stack, { spacing: 3, sx: { width: '100%' }, children: [_jsx(Spacer, { size: 2, sx: { width: '100%', backgroundColor: '#eee' } }), _jsx(CircularProgress, {}), _jsx(Spacer, { size: 2 })] }));
}
